export enum AnmeldungStatus {
    Angelegt = 'A',
    Verarbeitet = 'V',
    Storniert = 'S',
}
